import 'hammerjs'

export default class EventInfo {
  constructor(element) {
    this.el = element
    this.init();
  }

  init() {
    const {el} = this

    el.querySelectorAll('.event-info__head').forEach((elem) => {
      const hammerEl = new Hammer(elem);

      hammerEl.get('swipe').set({ direction: Hammer.DIRECTION_ALL });

      hammerEl.on('swipedown', function(ev) {
        el.classList.remove('active')
      });

      hammerEl.on('swipeup', function(ev) {
        el.classList.add('active')
      });
    })
  }
}
